// extracted by mini-css-extract-plugin
export default {"cls1":"VeloStrengthMeter-Warning_cls1__qcx-h","cls2":"VeloStrengthMeter-Warning_cls2__0MX2P VeloStrengthMeter-Warning_cls1__qcx-h"};